import api from "lib/api/api";

export const FETCH_TEACHER_COURSES_REQUEST = "FETCH_TEACHER_COURSES_REQUEST";
export const FETCH_TEACHER_COURSES_SUCCESS = "FETCH_TEACHER_COURSES_SUCCESS";
export const FETCH_TEACHER_COURSES_FAILURE = "FETCH_TEACHER_COURSES_FAILURE";

export const fetchTeacherCourses = () => async (dispatch) => {
  dispatch({ type: FETCH_TEACHER_COURSES_REQUEST });
  try {
    const res = await api.get("/admin-developer/teacher-courses");
    dispatch({ type: FETCH_TEACHER_COURSES_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({
      type: FETCH_TEACHER_COURSES_FAILURE,
      payload: err.message || "Failed to fetch teacher courses",
    });
  }
};
